"use client";

import { LogIn, RefreshCw } from "lucide-react";
import { logout } from "@/app/actions";
import { showApiErrorToast } from "@/lib/api-error-toast";
import { Button } from "./ui/button";

export default function BootstrapError({
  error,
  onRetry,
}: {
  error?: Error | null;
  onRetry: () => void;
}) {
  return (
    <div
      role="alert"
      className="absolute inset-0 flex items-center justify-center bg-background p-6"
    >
      <div className="flex w-full max-w-sm flex-col items-center gap-5 text-center">
        <div className="flex flex-col gap-2">
          <span className="font-headline text-xs font-semibold uppercase text-brand-accent">
            Libum Portal
          </span>
          <h1 className="text-xl font-semibold text-foreground">
            {error
              ? "We couldn't connect to Libum Portal."
              : "Your account is still loading."}
          </h1>
          <p className="text-sm text-muted-foreground">
            {error
              ? "Check your connection and retry, or sign in again."
              : "You can keep waiting, check your connection and retry, or sign in again."}
          </p>
          {error?.message && (
            <p className="select-text break-words text-sm text-muted-foreground">
              <span className="font-medium">Connection details: </span>
              {error.message}
            </p>
          )}
        </div>
        <div className="flex flex-wrap justify-center gap-2">
          <Button onClick={onRetry}>
            <RefreshCw />
            Retry
          </Button>
          <Button
            variant="secondary"
            onClick={async () => {
              try {
                await logout("sign-in");
              } catch (logoutError) {
                showApiErrorToast("Auth redirect failed", logoutError);
              }
            }}
          >
            <LogIn />
            Sign in
          </Button>
        </div>
      </div>
    </div>
  );
}
